import React from "react";
import Box from "./Box";
import { colors } from "./colors";

export interface TabProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

const Tab: React.FC<TabProps> = ({ label, isActive, onClick }): JSX.Element => (
  <Box
    component="button"
    onClick={onClick}
    sx={{
      height: "35px",
      padding: "0 24px",
      borderRadius: "100px",
      border: "none",
      cursor: "pointer",
      backgroundColor: isActive
        ? colors.tab.activeBackground
        : colors.tab.inactiveBackground,
      color: isActive
        ? colors.neutral.white
        : colors.tab.inactiveTextOpacity,
      fontSize: "16px",
      fontWeight: 400,
      fontFamily: "Outfit, sans-serif",
      lineHeight: "22px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: isActive
          ? colors.tab.activeHoverBackground
          : colors.tab.inactiveHoverBackground,
      },
    }}
  >
    {label}
  </Box>
);

export default Tab;
